module.exports = __webpack_public_path__ + "img/worker.9d61cb50.svg";